import urlToBase64 from "./urlToBase64";

export default async function (objects) {
  for (const obj of objects) {
    if (obj.src) {
      const base64 = await urlToBase64(obj.src);
      obj.src = base64;
      obj.crossOrigin = "Anonymous";
    }
  }
}
